import { useMutation, useQuery } from '@tanstack/react-query';
import React, { ReactNode, useCallback, useEffect, useMemo, useState } from 'react'
import HTTPClient from 'services/HTTPClient';
import { showErrorToast, showSuccessToast } from 'utils';
import Spinner from './Spinner';
import { IMedia } from './useReadingAssessmentResponse';

const useMutateGenerateImage = () => {
    type Params = { topic }
    return useMutation({
        mutationFn: async ({ topic }: Params) => {

            console.log("Generating image for..", topic)
            try {
                const url = `/api/tenant/generateImageForTopic`
                let query = { topic }
                let response = await HTTPClient.get().getJSONResult(url, query)
                showSuccessToast("Done")
                return response
            } catch (error: any) {
                showErrorToast(error.message)
            }
        }
    })
}

export default function useGenerateImage(): [IMedia | undefined, () => ReactNode, (topic: string) => void] {
    const [media, setMedia] = useState<IMedia>()
    const { isLoading: isGenerating, mutateAsync: generateImage } = useMutateGenerateImage()

    let generate = useCallback(
        (topic) => {
            generateImage({ topic }).then(i => {
                setMedia(i)
            })
        },
        [generateImage],
    )

    let renderer: () => ReactNode = useCallback(
        () => {
            return <div className='center' style={{
                position: "absolute",
                right: 60,
                top: 20,
                width: 150,
                height: 150,
                border: "1px dotted #acacac",
                backgroundImage: `url(${media?.url})`,
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover"
            }} >
                {isGenerating && <Spinner />}
            </div>
        },
        [media, isGenerating],
    )
    return [media, renderer, generate]

}